import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { LLPA_CAP_ACTION_TYPE } from '../actions';

const initialState = {};

const llpaCapCriteriaReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case LLPA_CAP_ACTION_TYPE.GET_LLPA_CAP_CRITERIA:
        return payload || initialState;

      case LLPA_CAP_ACTION_TYPE.ADD_LLPA_CAP_CRITERIA:
      case LLPA_CAP_ACTION_TYPE.EDIT_LLPA_CAP_CRITERIA:
        draft[payload.criteriaId] = payload;
        break;

      case LLPA_CAP_ACTION_TYPE.DELETE_LLPA_CAP_CRITERIA:
        delete draft[meta.criteriaId];
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default llpaCapCriteriaReducer;
